import { FC } from 'react';

import DatesSection from './DatesSection';
import ScriptureDataSection from './ScriptureDataSection';
import CoOwnersSection from './CoOwnersSection';
import CommentsSection from './CommentsSection';

const EncumbranceDetailsPageBody: FC = () => (
  <div className="encumbrance-details-page-body">
    <DatesSection />

    <CoOwnersSection />

    <ScriptureDataSection />

    <CommentsSection />
  </div>
);
export default EncumbranceDetailsPageBody;
